// @ts-nocheck
/* eslint-disable */

Object.defineProperty(exports, '__esModule', {
  value: true
});
Object.defineProperty(exports, 'Text', {
  enumerable: true,
  get: function get() {
    return _Text.Text;
  }
});

var _Text = require('./Text');


